<template>
	<b-modal size="lg" id="upload-enerp-modal" title="Upload dati EnerP" :no-close-on-backdrop="true" hide-footer>
		<div>
			<div class="my-3">
				<a href="/static/esempio-billaudit.csv" download>
					Scarica CSV d'esempio
				</a>
			</div>
			<div class="dnd-zone" :class="{ dragover }" @dragend="dragOverEnd" @drop="dropHandler"
				@dragover="dragOverHandler">
				<p>Trascina i <strong>file CSV</strong> qui oppure:<br />
					<br />
					<input accept="text/csv" multiple type="file" name="files" @change="filesSelected" ref="fileInput" />
				</p>
			</div>
			<div class="my-3">
				<table class="table table-striped">
					<tr>
						<th>File</th>
						<th>Sito</th>
						<th>Canale</th>
					</tr>
					<tr v-for="(item, i) in files">
						<td>{{ item.fileName }}</td>
						<td>
							<b-form-select required v-model="item.siteId" :options="sites" @change="setChannels(item)" />
						</td>
						<td>
							<b-form-select required v-if="item.siteId" v-model="item.channelCode"
								:options="item.channels" />
						</td>
					</tr>
				</table>
				<div class="my-3 text-right" v-if="isReadyToUpload">
					<b-btn @click="startUpload">Importa dati</b-btn>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	name: "UploadEnerp",
	data() {
		return {
			files: [],
			selectedFiles: [],
			dragover: false
		}
	},
	created() {

	},
	methods: {
		async startUpload() {
			const url = '/api/v1/bill-audit/upload'
			const formData = new FormData()
			const fetchOptions = {
				method: 'POST',
				body: formData,
			}
			this.$emit('uploading')
			for (let i = 0; i < this.files.length; i++) {
				const file = this.files[i]
				formData.append("file", file.file)
				formData.append("channelCode", file.channelCode)
				await fetch(url, fetchOptions)
			}
			this.$emit('completed')
		},
		setChannels(item) {
			item.channels = this.getChannels(item)
			if (item.channels.length) {
				item.channelCode = item.channels[0].value
			}
			this.files = [...this.files]
		},
		getChannels(item) {
			return this.userSites.
				find(site => site.id == item.siteId)
				.channels
				.map(channel => {
					return {
						value: channel.code,
						text: channel.name
					}
				})
		},
		autoSelect(item) {
			for (let i = 0; i < this.userSites.length; i++) {
				const site = this.userSites[i];
				const channel = site.channels.find(c => item.fileName.indexOf(c.code) >= 0)
				if (channel) {
					const filled = {
						...item,
						siteId: site.id,
						channelCode: channel.code
					}
					filled.channels = this.getChannels(filled)
					return filled
				}
			}
			return item
		},
		filesSelected(ev) {
			this.$refs.fileInput.files.forEach(file => {
				console.log(file)
				const ext = file.name.trim().split('.').pop().toLowerCase()
				if (ext == "csv") {
					this.files.push(this.autoSelect({
						fileName: file.name,
						file
					}))
				}
			})
		},
		dragOverHandler(ev) {
			ev.preventDefault();
			this.dragover = true
		},
		dragOverEnd(ev) {
			ev.preventDefault();
			this.dragover = false
		},
		dropHandler(ev) {
			ev.preventDefault()
			this.files = []
			if (ev.dataTransfer.items) {
				[...ev.dataTransfer.items].forEach((item, i) => {
					if (item.kind === "file") {
						const file = item.getAsFile();
						const ext = file.name.trim().split('.').pop().toLowerCase()
						if (ext == "csv") {
							this.files.push(this.autoSelect({
								fileName: file.name,
								file
							}))
						}
					}
				});
			}
		}
	},
	computed: {
		...mapGetters(['userSites']),
		isReadyToUpload() {
			return this.files.length &&
				this.files.filter(f => !!f.channelCode).length == this.files.length
		},
		sites() {
			return this.userSites.map(site => {
				return {
					value: site.id,
					text: site.name
				}
			})
		},
		channels() {
			return this.userSites
				.reduce((acc, curr) => {
					return acc.concat(curr.channels)
				}, [])
				.map(channel => {
					return {
						value: channel.code,
						text: channel.name,
					}
				})
		},
	}
}
</script>
<style scoped>
.dnd-zone {
	background-color: #f0f0f0;
	border: 2px dashed #ccc;
	text-align: center;
	padding: 20px 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-items: center;
}

.dragover {
	background-color: azure;
}

.dnd-zone p {
	margin: 0;
}</style>


// WEBPACK FOOTER //
// src/components/BillAudit/UploadEnerp.vue